import React, { Component } from 'react';
import { LinkContainer, hashHistory } from 'react-router-bootstrap';
import { Col, Form, FormGroup, FormControl, ControlLabel, Button, Checkbox } from 'react-bootstrap'


import Api from './../../../Global/Modules/Api'


class MededelingAdd extends Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.handleOptionsChange = this.handleOptionsChange.bind(this)
        this.state = {
            title: "",
            description: "",
            message: "",
            options: {
                0: false,
                1: false,
                2: false
            }
        }
    }

    // Function that will be executed when the submit button (Toevoegen) is pressed
    handleSubmit(event) {
        event.preventDefault()
        var formData = new FormData()
        Object.keys(this.state).forEach(e => {
            if (e == "options") {
                formData.append("visible", this.state[e][0])
                formData.append("homepage", this.state[e][1])
                formData.append("top", this.state[e][2])
            } else {
                formData.append(e, this.state[e])
            }

        })

        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)


        // TODO: Post payload to the API
        var that = this;
        Api.PostApiWithFile("api/news", formData, this.props.history)
            .then(response => {
                if (response !== undefined) {


                    Api.print(response)
                    this.setState({ errors: response });
                }
                else {
                    alert("News added")
                    window.location.href = '/admin/mededelingen';
                    // this.emptyForm()
                    // TODO: Show message OK, redirect to the previous page or something like this
                }
            })
    }

    // Function to manage the changes of the text fields and selects
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ [name]: value })
    }

    // Function to manage the changes of the option checkboxes
    handleOptionsChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        const checked = target.checked
        this.setState({ [name]: { ...this.state[name], [value]: checked } })
    }

    render() {
        return (
            <div>
                <Form horizontal onSubmit={this.handleSubmit}>
                    <FormGroup controlId="MededelingToevoegenTitel">
                        <Col componentClass={ControlLabel} sm={4}>
                            Titel *
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="title" value={this.state.title} required onChange={this.handleChange} />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="MededelingToevoegenAfbeelding">
                        <Col componentClass={ControlLabel} sm={4}>
                            Afbeelding
                        </Col>
                        <Col sm={6}>
                            <FormControl type="File" inputRef={input => this.fileInput = input} />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="MededelingToevoegenKortBeschrijving">
                        <Col componentClass={ControlLabel} sm={4}>
                            Korte beschrijving
                        </Col>
                        <Col sm={6}>
                            <FormControl componentClass="textarea" name="description" value={this.state.description} onChange={this.handleChange} rows="5" />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="MededelingToevoegenBericht">
                        <Col componentClass={ControlLabel} sm={4}>
                            Bericht *
                        </Col>
                        <Col sm={6}>
                            <FormControl componentClass="textarea" name="message" value={this.state.message} required onChange={this.handleChange} rows="5" />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="MededelingToevoegenOpties">
                        <Col componentClass={ControlLabel} sm={4}>
                            Opties
                        </Col>
                        <Col sm={6}>
                            {Api.getCommunicationOptions().map((option, index) =>
                                <Checkbox
                                    name="options"
                                    value={index}
                                    key={"option" + index}
                                    checked={this.state.options[index]}
                                    onChange={this.handleOptionsChange}>
                                    {option}
                                </Checkbox>
                            )}
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col sm={12}>
                            <LinkContainer to="/admin/mededelingen"><Button type="button" className="pull-left">Annuleren</Button></LinkContainer>
                            <Button type="submit" className="pull-right">Toevoegen</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

export default MededelingAdd;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Mededelingen/Add.js